module.exports = __webpack_public_path__ + "img/image-card-auth.8500434c.png";